import { Suspense, ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './index';
import { Loader } from '../../components/Loader';

interface TranslationProviderProps {
  children: ReactNode;
}

/**
 * Loading fallback component shown while translations are loading
 */
function TranslationLoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader />
    </div>
  );
}

/**
 * Provider component that wraps the app with i18n support.
 * Uses Suspense to handle async loading of translation files.
 * 
 * @example
 * <TranslationProvider>
 *   <App />
 * </TranslationProvider>
 */
export function TranslationProvider({ children }: TranslationProviderProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<TranslationLoadingFallback />}>
        {children}
      </Suspense>
    </I18nextProvider>
  );
}

export default TranslationProvider;

